import alarmService from '../service/alarmWatch'
const state = {
    query: {
        customer: "",
        levels: [],
        telemetry: "",
        dateRange: [],
        page: 1,
        pageSize: 10,
    },
    searchResult: {
        total: 0,
        alarmWatches: [],
    },
    telemetries: [
    ],
    loading: false,
}

const actions = {
    getAlarmWatch({ commit }, query) {
        commit('setLoading', true)
        return alarmService.getAlarmWatches(query).then(alarmWatches => {
            commit('setalarmWatches', alarmWatches);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

    getTelemetries({ commit }, query) {
        commit('setLoading', true)
        return alarmService.getTelemetries(query).then(telemetries => {
            commit('setTelemetries', telemetries);
        }).catch(() => {
            commit('setLoading', false)
        })
    },
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setalarmWatches(state, alarmWatches) {
        state.searchResult = alarmWatches
        state.loading = false
    },
    setTelemetries(state, telemetries) {
        state.telemetries = telemetries
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



